<template>
  <div id="import">
    <h1>{{$t('import.import')}}<div class="icon cross" @click="closeImport"></div></h1>
    <Info title="import.import" text="import.info" ></Info>
    <div class="import-container">
      <vue-dropzone
        ref="myVueDropzone" id="dropzone"
        :include-styling="false" :options="dropzoneOptions"
        @vdropzone-file-added="onDrop"
        @vdropzone-removed-file="onCancel">
      </vue-dropzone>
      <div class="drop-zone" v-show="!has_file">
        <div class="content">
          <div class="cloud"></div>
          <div class="text-content">
            {{$t('import.dragDrop')}} <br> {{$t('import.or')}} <br>
          </div>
          <div class="btn">
            {{$t('import.chooseFile')}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from './components/Navbar.vue'
import SideNavbar from './components/SideNavbar.vue'
import SelectFilter from './components/SelectFilter.vue'
import vueDropzone from 'vue2-dropzone'
import csv from 'csvtojson'
import Info from './components/Info.vue'

export default {
  name: 'home',
  components: {
    vueDropzone, Info
  },
  data() {
    return {
      searches: [],
      last_search_id: 0,
      show_filter: false,
      creating_filter_for: 0,
      has_file: 0,
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        maxFilesize: 2, // MB
        maxFiles: 4,
        chunking: true,
        chunkSize: 500, // Bytes
        addRemoveLinks: true, 
        createImageThumbnails: false, 
        autoProcessQueue: false
      }
    }
  },
  mounted() {
    // Everything is mounted and you can access the dropzone instance
    //const instance = this.$refs.el.dropzone
  },
  methods: {
    onDrop(file) {
      // let that = this
      var reader = new FileReader();
      reader.addEventListener("loadend", function(event) {
        let header = ''
        csv({
          output: "line"
        })
        .fromString(event.target.result)
        .on('header', (h) => {
          header = h[0]
        })
        .then((csvRow)=>{ 
          this.$emit("newDataImported", header, csvRow)
          this.$refs.myVueDropzone.removeAllFiles()
        })
      }.bind(this));
      reader.readAsText(file);
      this.has_file += 1
    },
    onCancel() {
      this.has_file -= 1
    }, 
    closeImport() {
      this.$emit("closeImport")
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/import.sass"
</style>
